<template>
  <div
    class="countdown__wrapper"
    v-show="isVisible"
  >
    <div
      class="countdown"
      v-bind:id="sektorId"
      v-bind:class="{ warning: warning }"
    ></div>
  </div>
</template>

<script>
import Sektor from './sektor.es6';
import { getters } from './timerState';

export default {
  name: 'SektorTimer',

  data() {
    return {
      sektor: null,
      warning: false,
      warningAngle: 90,
    };
  },

  computed: {
    ...getters,

    sektorId() {
      // eslint-disable-next-line no-underscore-dangle
      return `sektor-timer-${this._uid}`;
    },
  },

  mounted() {
    this.sektor = new Sektor(`#${this.sektorId}`, { angle: this.currentAngle });
  },

  watch: {
    currentAngle(value, prevValue) {
      console.log('cur-angle', value, prevValue);

      if (typeof value !== 'number') {
        return;
      }

      this.warning = value < this.warningAngle;

      if (value === 360 && prevValue && Math.abs(value - prevValue) > 25) {
        this.sektor.changeAngle(value);
        return;
      }

      this.sektor.animateTo(value, 1e3); // move during 1s
    },
  },
};
</script>
